import { render, staticRenderFns } from "./jsonDataLanding.vue?vue&type=template&id=4a8f486b&"
import script from "./jsonDataLanding.vue?vue&type=script&lang=js&"
export * from "./jsonDataLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports